import React from 'react';
import WebViewContext from './webview-context';

const ULTRACS_PREFIX = '/ultracs';

export default ({ element, props }) => {
  const isWebView = props?.pageContext?.isWebView ?? false;
  return (
    <WebViewContext.Provider value={{
      isWebView,
      pathPrefix: isWebView ? ULTRACS_PREFIX : '',
    }}>
      {element}
    </WebViewContext.Provider>
  );
};
